'use strict';

var DemandPostingTypeDirective = function DemandPostingTypeDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-posting-type.html'),
    controller: 'DemandPostingTypeController',
    scope: {
      type: '='
    },
    link: function link($scope, $element) {
      $element.on('DUMMY_EVENT', function () {});
    }
  };
};
DemandPostingTypeDirective.$inject = [];
module.exports = DemandPostingTypeDirective;